import { render, staticRenderFns } from "./ProductCreateEdit.vue?vue&type=template&id=077d4661&scoped=true&"
import script from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreateEdit.vue?vue&type=style&index=0&id=077d4661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d4661",
  null
  
)

export default component.exports